import { render } from "./MesaRegalos.vue?vue&type=template&id=40a026e9"
import script from "./MesaRegalos.vue?vue&type=script&lang=js"
export * from "./MesaRegalos.vue?vue&type=script&lang=js"

import "./MesaRegalos.vue?vue&type=style&index=0&id=40a026e9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__